module.exports = __webpack_public_path__ + "img/download-pdf.db4aa139.svg";